import { createApi } from "@reduxjs/toolkit/query/react";
import { getAxiosInstance } from "../../../api";

const axiosBaseQuery =
  () =>
  async ({ params, endpoint, method, body }) => {
    const api = await getAxiosInstance();
    const getParams = (key) => {
      if (params?.[key]) {
        return `${key}=${params[key]}&`;
      } else {
        return "";
      }
    };

    try {
      const response = await api[method](
        `${endpoint}?&${getParams("sort_by")}&sort_order=${
          params?.sort_order || "desc"
        }&page_size=${params?.page_size || "10"}&${getParams("search")}page=${
          params?.page || 1
        }&${getParams("faq_id")}`,
        body
      );

      return { data: response.data };
    } catch (axiosError) {
      let err = axiosError;

      return {
        data: err?.response?.data || err.message,
      };
    }
  };

export const faqsRtk = createApi({
  reducerPath: "faqsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["FAQs", "FAQsDeleteSingle", "FAQsDeleteMultiple", "Users-list"],
  endpoints: (builder) => ({
    getFAQsListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/faq/list`,
      }),
      providesTags: ["FAQs"],
    }),

    faqsDeleteSingle: builder.mutation({
      query: (values) => ({
        method: "delete",
        params: values,
        endpoint: `/admin/faq/delete`,
      }),
      invalidatesTags: ["FAQsDeleteSingle"],
    }),

    faqsDeleteMultiple: builder.mutation({
      query: (values) => ({
        method: "delete",
        params: values,
        endpoint: `/admin/faq/delete`,
      }),
      invalidatesTags: ["FAQsDeleteMultiple"],
    }),

    createNewFAQData: builder.mutation({
      query: (formData) => ({
        method: "post",
        endpoint: `/admin/faq/create`,
        body: formData,
      }),
      invalidatesTags: ["FAQs"],
    }),

    updateFAQListData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/admin/user/fields/update`,
      }),

      invalidatesTags: ["FAQs"],
    }),

    // Users-list

    getUsersListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/members/user`,
      }),
      providesTags: ["Users-list"],
    }),

    updateUsersListFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/admin/user/fields/update`,
      }),

      invalidatesTags: ["Users-list"],
    }),

    // Highlighted Profiles

    getHighlightedProfilesListData: builder.query({
      query: (values) => ({
        method: "get",
        params: values,
        endpoint: `/admin/highlighted-profiles`,
      }),
      providesTags: ["Users-list"],
    }),

    updateHighlightedProfilesListFieldsData: builder.mutation({
      query: (body) => ({
        method: "post",
        body,
        endpoint: `/admin/user/fields/update`,
      }),

      invalidatesTags: ["Users-list"],
    }),

  }),
});

export const {
  useFaqsDeleteMultipleMutation,
  useFaqsDeleteSingleMutation,
  useGetFAQsListDataQuery,
  useCreateNewFAQDataMutation,
  useUpdateFAQListDataMutation,
  useGetUsersListDataQuery,
  useUpdateUsersListFieldsDataMutation,
  useGetHighlightedProfilesListDataQuery,
  useUpdateHighlightedProfilesListFieldsDataMutation,
} = faqsRtk;
